import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Selector } from "../../../components/selector/Selector";
import { PrimaryButton } from "../../../components/primary/PrimaryButton";
import { FaArrowLeft } from "react-icons/fa";
import AvatarDetails from "../../../assets/icons/AvatarDetails";
// import "./index.css";
import { useNavigate, useParams } from "react-router-dom";
import {
  getLandsByUser,
  getUserByClientId,
  getUserById,
} from "../../../services/UsersService";
import { useDispatch } from "react-redux";
import {
  removeLand,
  selectClient,
} from "../../../features/userSlice/userSlice";
import { roles } from "../../../constants/roles";
import { formattedPrice } from "../../../utils";
import { MapDetails } from "../sale/maps/MapDetails";
import { useGetLandMap } from "../sale/maps/hooks/useGetLandMap";
import { useAuth } from "../../../hooks/useAuth";

const Items = ({ title, description, className }) => {
  return (
    <div className={`flex flex-col justify-start items-start ${className}`}>
      <p className="text-base" style={{ color: "#024E82" }}>
        {title}
      </p>
      <p className="text-sm">{description}</p>
    </div>
  );
};

const InfoClient = ({ client }) => {
  const { user } = useAuth();

  const navigate = useNavigate();
  const clientId = client.id;

  console.log(clientId, "---", client.roles);

  const [userClient, setUser] = useState(null);
  const [landId, setLandId] = useState(null);
  const [lands, setLands] = useState([]);
  const [selectedUserRole, setSelectedUserRole] = useState("");
  const [showSelectorLands, setShowSelectorLands] = useState(false);

  const dispatch = useDispatch();
  const { handleLendMap, lend } = useGetLandMap();
  //const lands = useMemo(() => userClient?.client?.lands || [], [userClient?.client?.lands]);

  const landsList = useMemo(
    () => lands?.map((l) => ({ value: l.id, label: l.identifying_label })),
    [lands]
  );

  const selectedLand = useMemo(() => {
    if (!landId) {
      return lands?.[0] || null;
    }

    return lands.find((l) => l.id === landId);
  }, [landId, lands]);

  const goBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const navigateToProgress = useCallback(
    (clientId) => {
      if (clientId) {
        getUserByClientId({ clientId: clientId }).then((response) => {
          const { data: theUser } = response?.data;
          dispatch(selectClient(theUser));
          navigate(`/admin/details/${userClient?.id}/${theUser?.id}`);
        });
      } else {
        getUserById({ id: userClient?.id }).then((response) => {
          const { data: theUser } = response?.data;
          const userRole = theUser?.roles?.[0]?.name?.toLowerCase();
          if (userRole === roles.CLIENT) {
            dispatch(selectClient(theUser));
            navigate(`/admin/details/${userClient?.id}/${theUser?.id}`);
          }
        });
      }
    },
    [dispatch, navigate, userClient?.id]
  );

  useEffect(() => {
    setSelectedUserRole(client?.roles?.[0]?.name || "");

    setUser(client);

    // getUserById({ id: clientId }).then((response) => {
    //   const { data } = response?.data;
    //   setSelectedUserRole(data?.roles?.[0]?.name || "");

    //   setUser(client);
    // });
  }, [client]);

  useEffect(() => {
    if (!clientId || !selectedUserRole) return;

    getLandsByUser({ user_id: clientId, role: selectedUserRole })
      .then((response) => {
        setLands(response.data?.lands);
      })
      .finally(() => {
        setTimeout(() => {
          setShowSelectorLands(true);
        }, 1000);
      });

    console.log("salio");
  }, [clientId, selectedUserRole]);

  console.log(lands);

  useEffect(() => {
    dispatch(selectClient({}));
    dispatch(removeLand());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedLand) {
      handleLendMap(selectedLand);
    }
  }, [handleLendMap, selectedLand]);

  if (!userClient) {
    return null;
  }

  return (
    <div className="p-5 DashboardSeller max-w-screen-xl">
      <div className="bg-white rounded-xl">
        <div className="flex items-center px-10 pl-9">
          <div className="m-4 ml-0">
            <AvatarDetails />
          </div>
          <div className="w-full flex flex-col md:flex-row justify-between items-start">
            <div>
              <h1 className="userTitle">{`${userClient?.name || ""} ${
                userClient?.last_name || ""
              }`}</h1>
              <span>Lorem Ipsum</span>
            </div>
            <div className="flex flex-col items-end text-primary mr-0 md:mr-40 pr-0 md:pr-10">
              <strong className="text-primary ">{`N: ${
                userClient?.id || ""
              }`}</strong>
              {/* <strong className="text-primary ">
                {user?.user?.roles?.[0]?.name?.toLowerCase() === roles.SELLER
                  ? "VENDEDOR:"
                  : "ADMINISTRADOR:"}
                {` ${userClient?.seller?.administrator_name ||
                  `${user?.user?.name} ${user?.user?.last_name || ""}`
                  }`}
              </strong> */}
              {/*<strong className="text-primary">{`ROLE ${userClient.id || ""}`}</strong>*/}
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-start items-center w-full p-10 pt-0 gap-5 md:gap-20">
          <div>
            <Items
              className="mt-8 mr-5"
              title="Código de país"
              description={userClient?.country_code}
            />
            <Items
              className="mt-8 mr-5"
              title="Código postal"
              description={userClient?.client?.zip_code}
            />
            <Items
              className="mt-8 mr-5"
              title="Correo electrónico"
              description={userClient?.email}
            />
          </div>
          <div>
            <Items
              className="mt-8 mr-5"
              title="Telefono"
              description={userClient?.phone}
            />
            <Items
              className="mt-8 mr-5"
              title="Dirección"
              description={userClient?.client?.full_address}
            />
            <div style={{ height: "5rem" }} />
          </div>
        </div>
      </div>

      <div className="rounded-xl" style={{ backgroundColor: "#F1F3F4" }}>
        <div className="flex flex-col md:flex-row justify-start items-center w-full mt-10 pl-0 md:pl-10 pt-10">
          <h3 className="title text-2xl mr-0 md:mr-10">Terrenos</h3>
          <div className="w-1/5" style={{ minWidth: "10rem" }}>
            {showSelectorLands && (
              <Selector
                name="land"
                options={landsList}
                defaultValue={{
                  value: landsList[0]?.id,
                  label: landsList[0]?.label || "Seleccionar",
                }}
                onChange={(e) => setLandId(e.value)}
                isNewVersion
              />
            )}
          </div>
        </div>
        <div className="flex flex-col md:flex-row justify-start items-center md:items-end w-full p-10 gap-5 ">
          {/* <div
            className="bg-gray rounded-md"
            style={{
              minWidth: "15rem",
              minHeight: "15rem",
              maxWidth: "15rem",
              maxHeight: "15rem",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                width: "150%",
                height: "150%",
                position: "absolute",
                top: -50,
                bottom: 0,
                left: -50,
                right: 0,
              }}
            >
              {lend?.render?.(
                [selectedLand],
                selectedLand,
                Number(selectedLand?.lote || 0)
              )}
            </div>
          </div> */}
          {/* <div className="show-button">
            <PrimaryButton
              disabled={landsList.length > 0 && !selectedLand}
              onClick={() => navigateToProgress(selectedLand?.client_id)}
            >
              Progreso
            </PrimaryButton>
          </div> */}

          <table className="w-full">
            <thead>
              <tr>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="w-1/2">
                  <Items
                    className="mt-0"
                    title="Nombre"
                    description={selectedLand?.identifying_label || ""}
                  />
                </td>
                <td className="w-1/2">
                  <Items
                    className="mt-0"
                    title="Medidas"
                    description={selectedLand?.surface || ""}
                  />
                </td>
                <td>
                  <Items
                    className="mt-0"
                    title="Estatus"
                    description={selectedLand?.status || ""}
                    styleDescription="font-bold"
                  />
                </td>
              </tr>
              <tr>
                <td className="w-1/2">
                  <Items
                    className="mt-8 mr-5"
                    title="Adelanto"
                    description={formattedPrice(selectedLand?.advance)}
                  />
                </td>
                <td className="w-1/2">
                  <Items
                    className="mt-8 mr-5"
                    title="Ubicación"
                    description={selectedLand?.location || ""}
                  />
                </td>
              </tr>
              <tr>
                <td className="w-1/2">
                  <Items
                    className="mt-8 mr-5"
                    title="Interés"
                    description={selectedLand?.advance ? "%0" : ""}
                  />
                </td>
                <td className="w-1/2">
                  <Items
                    className="mt-8 mr-5"
                    title="Descripción"
                    description={selectedLand?.description || ""}
                  />
                </td>
              </tr>
              <tr>
                <td className="w-1/2">
                  <Items
                    className="mt-8 mr-5"
                    title="Mensualidad"
                    description={selectedLand?.id ? "240" : ""}
                  />
                </td>
                <td className="w-1/2">
                  <div className=" flex flex-col md:flex-row justify-start items-end w-full py-10 gap-5">
                    <PrimaryButton
                      disabled={landsList.length > 0 && !selectedLand}
                      onClick={() =>
                        navigateToProgress(selectedLand?.client_id)
                      }
                    >
                      Progreso
                    </PrimaryButton>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          {/*<div className="flex flex-col md:flex-row justify-start items-center w-full">
            <div>
              <Items
                title="Nombre"
                description={selectedLand?.identifying_label || ""}
              />
              <Items
                title="Adelanto"
                description={selectedLand?.advance || ""}
              />
            </div>
            <div>
              <Items title="Interés" description="" />
              <Items
                title="Medidas"
                description={selectedLand?.surface || ""}
              />
            </div>
            <div>
              <Items
                title="Ubicación"
                description={selectedLand?.location || ""}
              />
              <Items
                title="Descripción"
                description={selectedLand?.description || ""}
              />
            </div>
          </div>*/}
        </div>
        {/* <div className=" flex flex-col md:flex-row justify-start items-end w-full p-10 gap-5 progress-button">
          <PrimaryButton
            disabled={landsList.length > 0 && !selectedLand}
            onClick={() => navigateToProgress(selectedLand?.client_id)}
          >
            Progreso
          </PrimaryButton>
        </div> */}
      </div>
    </div>
  );
};

export default InfoClient;
